/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2020. All Rights Reserved.
 #*
 #*===================================================================
 */

export interface ClientFilter {
  name: string;
  value: number;
  selected?: boolean;
  nameClass?: string;
  valueClass?: string;
  displayedName?: string;
  btnName?: string;
  btnAction?: any;
  type?: string;
}

export interface ClientFilters {
  widgetTop: ClientFilter;
  widgetLeft: ClientFilter;
  widgetCenter: ClientFilter;
  widgetRight: ClientFilter;
}

export interface ClientFilterEvent {
  companyType: string;
  accountStatus?: string | string[];
  selected?: boolean;
  type?: string;
}

export enum CLIENT_FILTER_NAMES {
  // Brokers
  BROKERS = 'Brokers',
  ACTIVE = 'Active',
  LOCKED = 'Locked',
  REQUESTED_TO_CANCEL = 'Requested To Cancel',
  // Shippers
  SHIPPERS = 'Shippers',
  // Shippers
  CARRIERS = 'Carriers',
}
